import { Reveal } from "@/components/Reveal";
import { ChapterLabel } from "@/components/ChapterLabel";

const frases = [
  "Pienso demasiado y casi nunca sé con quién compartirlo.",
  "Me interesan temas que mi entorno no entiende.",
  "Siento que tengo que moderarme para no parecer intenso.",
  "Vivo pequeñas fricciones que otras personas no perciben.",
  "Quiero conectar sin tener que justificar cómo funciona mi mente.",
  "Me siento solo incluso cuando estoy acompañado.",
];

export const Identificacion = () => (
  <section className="bg-[#0E1628] px-5 py-24 md:py-32">
    <div className="mx-auto max-w-[1100px]">
      <Reveal>
        <ChapterLabel number="01" testId="chapter-identificacion" />
        <h2 className="max-w-3xl text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
          Quizá no te falte gente alrededor. Te falta sentirte comprendido.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-8 max-w-3xl space-y-5 text-base leading-relaxed text-[#9AA6BE] md:text-lg">
          <p>
            Puedes tener amigos, familia, pareja o compañeros y, aun así, sentir
            que nadie entra realmente en tu mundo mental. Cuando piensas con más
            intensidad, conectas ideas constantemente o experimentas el día de
            una forma diferente, muchas conversaciones se quedan en la
            superficie.
          </p>
          <p className="font-medium text-[#E8E4DC]">
            Esta comunidad nace para que no tengas que guardártelo todo,
            reducirte para encajar ni esperar semanas para encontrar a alguien
            con quien hablar.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="identificacion-cards">
        {frases.map((frase, i) => (
          <Reveal key={frase} delay={0.05 * i} className="h-full">
            <div className="flex h-full items-start gap-4 rounded-2xl border border-[#22304D] bg-[#131D33] p-6 transition-[transform,border-color] duration-200 hover:-translate-y-1 hover:border-[#8B7CF6]/40">
              <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-[#8B7CF6]" />
              <p className="text-sm leading-relaxed text-[#E8E4DC] md:text-base">
                “{frase}”
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
